/* kip home, v1.0 behaviour layer (Oct 2026). Shared by every kh- section; the same motion as the For Business page.
   Vanilla, no dependencies. Runs once per page; KH.init(scope) re-binds a section after the theme editor reloads it. */
(function () {
  'use strict';
  if (window.KH && window.KH.v) return;

  var docEl = document.documentElement;
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var IO = 'IntersectionObserver' in window;
  /* a mouse or trackpad. Phones and tablets scroll on their own thread, so scroll-linked motion and smooth scroll stay off there:
     anything moved from script lags a frame behind the finger and reads as jitter */
  var FINE = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : { matches: true };
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function once(el, key) { if (el['_kh' + key]) return false; el['_kh' + key] = 1; return true; }
  function play(v) { try { var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {} }

  /* bare: a kh- section on a page that isn't built from them (the shop). Leave that page's own look alone. */
  var BARE = docEl.hasAttribute('data-kh-bare');
  if (!BARE) docEl.classList.add('kh-page', 'kh-anim');
  if (RM) docEl.classList.add('kh-rm');

  /* ---------- hero: tuck under the fixed announcement bar, a slow drift on scroll ---------- */
  function fitHero() {
    var hero = $('.kh-hero'); if (!hero) return;
    var anc = $('.kip-anc');
    var ab = anc ? Math.round(anc.getBoundingClientRect().bottom) : 0;
    if (ab < 0 || ab > 80) ab = 0;
    docEl.style.setProperty('--kh-anc', ab + 'px');
    hero.style.setProperty('--kh-pull', '0px');
    var top = hero.getBoundingClientRect().top + (window.scrollY || window.pageYOffset || 0);
    if (top < 400) hero.style.setProperty('--kh-pull', (ab - top) + 'px');
  }
  var heroPend = false;
  var driftOn = null;
  function driftHero() {
    heroPend = false;
    var hero = $('.kh-hero'); if (!hero || RM) return;
    /* the drift runs on big screens with a mouse only, as on the Digital wellness page */
    var on = FINE.matches && window.innerWidth > 900;
    if (!on) { if (driftOn !== false) { driftOn = false; hero.style.setProperty('--py', '0px'); } return; }
    driftOn = true;
    var h = hero.offsetHeight || 1, y = window.scrollY || window.pageYOffset || 0;
    hero.style.setProperty('--py', (clamp(y, 0, h) * 0.22).toFixed(1) + 'px');
  }
  function reqDrift() { if (!heroPend) { heroPend = true; requestAnimationFrame(driftHero); } }

  /* ---------- reveal on the way in ---------- */
  var riseIO = IO && !RM ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); riseIO.unobserve(e.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }) : null;
  function rise(scope) {
    $$('[data-kh-rise]', scope).forEach(function (el) {
      if (!once(el, 'rise')) return;
      if (riseIO) riseIO.observe(el); else el.classList.add('in');
    });
  }

  /* ---------- accordions (good to know, questions) ---------- */
  function accordions(scope) {
    $$('.kh-acc', scope).forEach(function (acc) {
      if (!once(acc, 'acc')) return;
      var items = $$('.kh-acc-i', acc);
      items.forEach(function (it) {
        var b = $('.kh-acc-b', it); if (!b) return;
        b.addEventListener('click', function () {
          var open = !it.classList.contains('open');
          items.forEach(function (o) { o.classList.remove('open'); var ob = $('.kh-acc-b', o); if (ob) ob.setAttribute('aria-expanded', 'false'); });
          if (open) { it.classList.add('open'); b.setAttribute('aria-expanded', 'true'); }
        });
      });
      var more = acc.parentNode && $('.kh-more', acc.parentNode);
      if (more && once(more, 'more')) more.addEventListener('click', function () {
        var showing = more.getAttribute('aria-expanded') === 'true';
        var k = 0;
        items.forEach(function (it) {
          if (!it.hasAttribute('data-x')) return;
          if (showing) { it.classList.add('x'); it.classList.remove('rv', 'open'); }
          else { it.classList.remove('x'); it.classList.add('rv'); it.style.setProperty('--d', (k++ * 0.05).toFixed(2) + 's'); }
        });
        more.setAttribute('aria-expanded', showing ? 'false' : 'true');
        var t = $('.kh-more-t', more); if (t) t.textContent = more.getAttribute(showing ? 'data-more' : 'data-less');
        more.classList.toggle('is-less', !showing);
        if (showing) { var r = acc.getBoundingClientRect(); if (r.top < 0) { var y = r.top + (window.scrollY || 0) - 140; if (window.lenis && window.lenis.scrollTo) window.lenis.scrollTo(y); else window.scrollTo(0, y); } }
      });
    });
  }

  /* ---------- the film: fetched only when it is close ---------- */
  var filmIO = IO ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { loadFilm(e.target); filmIO.unobserve(e.target); } });
  }, { rootMargin: '600px 0px' }) : null;
  function loadFilm(v) {
    if (!v.hasAttribute('data-kh-lazy')) return;
    v.removeAttribute('data-kh-lazy');
    var d = v.getAttribute('data-kh-src'); if (d) { v.src = d; v.removeAttribute('data-kh-src'); }
    $$('source[data-kh-src]', v).forEach(function (s) { s.src = s.getAttribute('data-kh-src'); s.removeAttribute('data-kh-src'); });
    v.load();
    if (!RM) play(v);
  }
  function films(scope) {
    $$('video[data-kh-lazy]', scope).forEach(function (v) {
      if (!once(v, 'film')) return;
      if (filmIO) filmIO.observe(v); else loadFilm(v);
    });
  }

  /* ---------- reels: fetched early, played only while mostly on screen, tap for sound ----------
     Only the films you can actually see are decoding, so scrolling up and down past the grid stays smooth;
     a film with its sound on goes quiet again once it leaves the screen. */
  function srcIn(v) { var s = v.getAttribute('data-kh-src'); if (s) { v.src = s; v.removeAttribute('data-kh-src'); } }
  var reelLoad = IO ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { srcIn(e.target); reelLoad.unobserve(e.target); } });
  }, { rootMargin: '700px 0px' }) : null;
  var reelPlay = IO ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var v = e.target, fig = v.closest('.kh-reel');
      if (e.isIntersecting && e.intersectionRatio >= 0.5) { srcIn(v); if (!RM) play(v); }
      else {
        v.pause();
        if (!v.muted) { v.muted = true; if (fig) fig.classList.remove('sound'); }
      }
    });
  }, { threshold: [0, 0.5, 1] }) : null;
  function reels(scope) {
    $$('.kh-reels', scope).forEach(function (wrap) {
      if (!once(wrap, 'reels')) return;
      var figs = $$('.kh-reel', wrap);
      figs.forEach(function (fig) {
        var v = $('video', fig);
        if (!v) return;
        v.addEventListener('playing', function () { fig.classList.add('playing'); });
        v.addEventListener('pause', function () { fig.classList.remove('playing'); });
        if (reelPlay) { reelLoad.observe(v); reelPlay.observe(v); } else srcIn(v);
        fig.addEventListener('click', function () {
          var on = v.muted;
          figs.forEach(function (o) { var ov = $('video', o); if (ov && ov !== v) { ov.muted = true; o.classList.remove('sound'); } });
          v.muted = !on;
          fig.classList.toggle('sound', on);
          var b = $('.kh-reel-mute', fig); if (b) b.setAttribute('aria-label', on ? 'Mute' : 'Turn the sound on');
          if (v.paused) play(v);
        });
      });
    });
  }

  /* ---------- while the page is moving, hover effects wait (no panels opening or films zooming under a still cursor) ---------- */
  var scrollT = null;
  function scrolling() {
    if (!docEl.classList.contains('kh-scrolling')) docEl.classList.add('kh-scrolling');
    clearTimeout(scrollT);
    scrollT = setTimeout(function () { docEl.classList.remove('kh-scrolling'); }, 160);
  }

  /* ---------- everyday moments: one panel open at a time, as the For Business stories ---------- */
  function moments(scope) {
    $$('[data-kh-mp]', scope).forEach(function (root) {
      if (!once(root, 'mp')) return;
      var row = $('.kh-mp-row', root), panels = $$('.kh-mp-p', root), segWrap = $('.kh-mp-segs', root);
      if (!row || !panels.length) return;
      var metaLabel = $('.kh-mp-ml', root), metaCount = $('.kh-mp-mc', root);
      var interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;
      root.style.setProperty('--kh-int', interval / 1000 + 's');
      var desktop = window.matchMedia('(min-width: 990px)');
      var current = 0, timer = null, inView = false, L = panels.length, paused = false;
      var segs = panels.map(function (p, n) {
        var s = document.createElement('button'); s.type = 'button'; s.setAttribute('aria-label', 'Go to ' + (p.getAttribute('aria-label') || 'moment ' + (n + 1)));
        var b = document.createElement('b'); b.appendChild(document.createElement('i')); s.appendChild(b);
        s.addEventListener('click', function () { go(n); });
        if (segWrap) segWrap.appendChild(s);
        return s;
      });
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function paint() {
        panels.forEach(function (p, n) {
          var on = n === current;
          p.classList.toggle('is-open', on); p.classList.remove('is-timing');
          p.setAttribute('aria-expanded', on ? 'true' : 'false');
          segs[n].className = n < current ? 'past' : '';
        });
        if (metaLabel) metaLabel.textContent = panels[current].getAttribute('aria-label') || '';
        if (metaCount) metaCount.textContent = pad(current + 1) + ' / ' + pad(L);
        if (timer) { void panels[current].offsetWidth; panels[current].classList.add('is-timing'); segs[current].className = 'run'; }
      }
      function stop() { clearInterval(timer); timer = null; }
      function restart() {
        stop();
        if (!RM && inView && !paused && L > 1) timer = setInterval(function () { current = (current + 1) % L; paint(); }, interval);
        paint();
      }
      function go(i) { current = (i + L) % L; restart(); }
      panels.forEach(function (p, i) {
        function pick() { if (!desktop.matches || i === current) return; go(i); }
        p.addEventListener('mouseenter', pick); p.addEventListener('click', pick); p.addEventListener('focus', pick);
        p.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); } });
      });
      /* hold the open moment while the pointer rests on it, so the words can be read */
      row.addEventListener('mouseenter', function () { if (desktop.matches) { paused = true; restart(); } });
      row.addEventListener('mouseleave', function () { if (paused) { paused = false; restart(); } });
      $$('.kh-mp-tap.prev, .kh-mp-arrow.prev', root).forEach(function (b) { b.addEventListener('click', function () { go(current - 1); }); });
      $$('.kh-mp-tap.next, .kh-mp-arrow.next', root).forEach(function (b) { b.addEventListener('click', function () { go(current + 1); }); });
      var tx = null;
      row.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
      row.addEventListener('touchend', function (e) {
        if (tx === null) return;
        var dx = e.changedTouches[0].clientX - tx; tx = null;
        if (Math.abs(dx) > 40) go(dx < 0 ? current + 1 : current - 1);
      }, { passive: true });
      if (IO) new IntersectionObserver(function (es) { inView = es[0].isIntersecting; restart(); }, { threshold: 0.35 }).observe(row);
      else inView = true;
      restart();
    });
  }

  /* ---------- a day with kip: the For Business day chart, told for one person's day ---------- */
  function day(scope) {
    $$('[data-kd]', scope).forEach(function (root) {
      if (!once(root, 'kd')) return;
      var ce = $('script[data-kd-cfg]', root), cfg;
      try { cfg = JSON.parse(ce.textContent); } catch (e) { return; }
      var band = $('[data-band]', root), head = $('[data-head]', root), viz = $('.kd-viz', root);
      if (!band || !cfg.moments || !cfg.moments.length) return;
      var T0 = 6, SPAN = 18;
      function toH(s) { var m = String(s || '').match(/(\d{1,2})[:.](\d{2})/); return m ? +m[1] + (+m[2]) / 60 : 0; }
      function pct(t) { return ((t - T0) / SPAN * 100).toFixed(3) + '%'; }
      function dur(a, b) { var m = Math.round((b - a) * 60); if (m === 60) return '1 hr'; if (m < 90) return m + ' mins'; return (Math.round(m / 30) / 2) + ' hrs'; }
      var V = cfg.moments.map(function (m) {
        var a = clamp(toH(m.start), T0, T0 + SPAN - .25), b = toH(m.end);
        if (b <= a) b = b === 0 ? 24 : a + 1;
        b = clamp(b, a + .25, 24);
        return { a: a, b: b, m: m, dur: dur(a, b), ix: [] };
      });
      var seed = 11; function rnd() { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; }
      function spread(total, w) {
        var tot = 0, out = [], k, h, j; for (k in w) tot += w[k];
        for (h in w) { var c = Math.round(w[h] / tot * total); for (j = 0; j < c; j++) out.push(+h + rnd()); }
        while (out.length > total) out.pop(); while (out.length < total) out.push(12 + rnd());
        return out.sort(function (a, b) { return a - b; });
      }
      /* when in the day people pick up their phone, and when it pings: the same curve as For Business */
      var wp = { 6: 3, 7: 14, 8: 15, 9: 12, 10: 10, 11: 15, 12: 15, 13: 12, 14: 10, 15: 10, 16: 10, 17: 12, 18: 13, 19: 15, 20: 14, 21: 13, 22: 9, 23: 5 };
      var wn = { 6: 3, 7: 8, 8: 10, 9: 12, 10: 11, 11: 10, 12: 10, 13: 9, 14: 9, 15: 9, 16: 9, 17: 10, 18: 9, 19: 9, 20: 8, 21: 6, 22: 4, 23: 2 };
      function makeDots(list, cls, y0, yr) {
        var frag = document.createDocumentFragment();
        var out = list.map(function (t) { var e = document.createElement('span'), y = y0 + rnd() * yr; e.className = cls; e.style.left = pct(t); e.style.top = y.toFixed(1) + '%'; frag.appendChild(e); return { t: t, el: e, c: '' }; });
        band.insertBefore(frag, head); return out;
      }
      function inV(t) { for (var i = 0; i < V.length; i++) if (t >= V[i].a && t < V[i].b) return true; return false; }
      var P = makeDots(spread(cfg.pickups || 186, wp), 'kd-p', 12, 76);
      var N = makeDots(spread(cfg.notifications || 275, wn), 'kd-n', 8, 84);
      var keep = {};
      P.forEach(function (x) { x.w = inV(x.t); });
      N.forEach(function (x) { x.w = inV(x.t); });
      V.forEach(function (v) {
        P.forEach(function (x, i) { if (x.t >= v.a && x.t < v.b) v.ix.push(i); });
        var kk = Math.min(v.m.keep || 0, v.ix.length);
        for (var j = 0; j < kk; j++) keep[v.ix[Math.floor((j + .5) / kk * v.ix.length)]] = 1;
      });
      var ticks = $('[data-ticks]', root);
      if (ticks) { var on = +ticks.getAttribute('data-on') || 0, th = ''; for (var ti = 1; ti <= 60; ti++) th += '<i' + (ti <= on ? ' class="on"' : '') + '></i>'; ticks.innerHTML = th; }

      var cards = $$('[data-card]', root), paths = $$('[data-stem]', root), pins = $$('[data-pin]', root), wins = $$('[data-win]', root);
      var txts = cards.map(function (c) { return $('[data-txt]', c); }), badges = cards.map(function (c) { return $('[data-badge]', c); }), gWas = [];
      V.forEach(function (v, i) {
        if (pins[i]) pins[i].style.left = pct((v.a + v.b) / 2);
        if (wins[i]) {
          wins[i].style.left = pct(v.a); wins[i].style.width = ((v.b - v.a) / SPAN * 100).toFixed(3) + '%';
          var mins = Math.round((v.b - v.a) * 60);
          $('em', wins[i]).textContent = mins < 60 || mins % 60 ? (mins < 90 ? mins + 'm' : (Math.round(mins / 30) / 2) + 'h') : (mins / 60) + 'h';
        }
      });
      var q = function (s) { return $(s, root); };
      var el = { sw: q('[data-sw]'), sub: q('[data-sw-sub]'), tag: q('[data-tag]'), clock: q('[data-clock]'), pc: q('[data-pc]'), nc: q('[data-nc]'), sth: q('[data-sth]'), stm: q('[data-stm]'),
        stb: q('[data-st-bar]'), sts: q('[data-st-sbar]'), pb: q('[data-p-bar]'), nb: q('[data-n-bar]'), pss: q('[data-p-sbar]'), nss: q('[data-n-sbar]'),
        ps: q('[data-p-saved]'), ns: q('[data-n-saved]'), ss: q('[data-st-saved]'), pl: q('[data-p-lab]'), nl: q('[data-n-lab]'), sl: q('[data-st-lab]') };
      var kip = false, p = RM ? 1 : 0, t0 = 0, raf = 0, running = false, D = (cfg.duration || 14) * 1000, HOLD = (cfg.hold || 5) * 1000;
      function set(node, txt) { if (node && node.textContent !== txt) node.textContent = txt; }
      function tog(node, c, v) { v = !!v; if (node && node.classList.contains(c) !== v) node.classList.toggle(c, v); }
      function xform(node, v) { if (node && node._x !== v) { node.style.transform = v; node._x = v; } }
      /* measured once, and again only when the layout really changes: no forced layout inside the loop */
      var Wd = 0, tagW = {}, wide = false;
      function measure() {
        Wd = band.clientWidth; tagW = {};
        wide = cards[0] ? cards[0].offsetWidth >= 260 : false;
        var vw = viz.clientWidth || 1;
        paths.forEach(function (pth, i) {
          var c = cards[i], v = V[i]; if (!c || !v) return;
          var cx = ((c.offsetLeft + c.offsetWidth / 2) / vw * 1000).toFixed(1), wx = (((v.a + v.b) / 2 - T0) / SPAN * 1000).toFixed(1);
          pth.setAttribute('d', 'M' + cx + ' 0C' + cx + ' 22 ' + wx + ' 18 ' + wx + ' 40');
        });
      }
      function tw(txt) { var k = txt.length; if (tagW[k] == null) tagW[k] = el.tag.offsetWidth; return tagW[k]; }

      function render() {
        var now = T0 + p * SPAN, pc = 0, nc = 0, ps = 0, ns = 0, i, x, on, g, kp, c, nowIx = 0;
        for (i = 0; i < P.length; i++) { x = P[i]; on = x.t <= now; g = kip && x.w && !keep[i]; kp = kip && x.w && keep[i]; if (on && !g) pc++; if (on && g) ps++; c = 'kd-p' + (on ? ' on' : '') + (g ? ' gone' : '') + (kp ? ' kept' : ''); if (c !== x.c) { x.el.className = c; x.c = c; } }
        for (i = 0; i < N.length; i++) { x = N[i]; on = x.t <= now; g = kip && x.w; if (on && !g) nc++; if (on && g) ns++; c = 'kd-n' + (on ? ' on' : '') + (g ? ' gone' : ''); if (c !== x.c) { x.el.className = c; x.c = c; } }
        V.forEach(function (v, k) {
          var live = now >= v.a, n = 0, m = 0, j;
          if (live) nowIx = k;
          for (j = 0; j < v.ix.length; j++) { if (P[v.ix[j]].t <= now) { n++; if (keep[v.ix[j]]) m++; } }
          var card = cards[k]; if (!card) return;
          tog(card, 'is-live', live); tog(card, 'is-kip', kip);
          set(txts[k], kip ? v.m.textKip : v.m.text);
          var cnt = kip ? m : n;
          set(badges[k], (kip && wide ? (cfg.badgeKip || 'kip on') + ' · ' : '') + cnt + (cnt === 1 ? ' pickup' : ' pickups') + (wide ? ' in ' + v.dur : ''));
          var gv = clamp((now - v.a) / (v.b - v.a), 0, 1).toFixed(3);
          if (wins[k] && gWas[k] !== gv) { wins[k].style.setProperty('--g', gv); tog(wins[k], 'run', gv > 0); gWas[k] = gv; }
          tog(paths[k], 'on', live);
        });
        cards.forEach(function (cd, k) { tog(cd, 'is-now', k === nowIx); });
        var ov = 0; if (kip) V.forEach(function (v) { ov += Math.max(0, Math.min(now, v.b) - v.a); });
        var total = cfg.screen || 270, sv = Math.round(total * ov / SPAN), stv = Math.round(total * (now - T0) / SPAN), stShown = kip ? stv - sv : stv;
        set(el.sth, String(Math.floor(stShown / 60))); set(el.stm, String(stShown % 60).padStart(2, '0'));
        set(el.pc, String(pc)); set(el.nc, String(nc));
        function bar(a, b, v, sv2, max) { xform(a, 'scaleX(' + (v / max).toFixed(4) + ')'); xform(b, 'translateX(' + (v / max * 100).toFixed(2) + '%) scaleX(' + (sv2 / max).toFixed(4) + ')'); }
        bar(el.stb, el.sts, stv - sv, sv, total); bar(el.pb, el.pss, pc, ps, P.length); bar(el.nb, el.nss, nc, ns, N.length);
        set(el.ss, (sv < 60 ? sv + 'm' : Math.floor(sv / 60) + 'h ' + (sv % 60) + 'm') + ' ' + (cfg.savedTime || ''));
        set(el.ps, ps + ' ' + (cfg.savedFewer || '')); set(el.ns, ns + ' ' + (cfg.savedFewer || ''));
        [el.ss, el.ps, el.ns].forEach(function (s) { tog(s, 'has', kip && (ps > 0 || ns > 0)); });
        set(el.sl, kip ? cfg.stLabKip : cfg.stLab); set(el.pl, kip ? cfg.pLabKip : cfg.pLab); set(el.nl, kip ? cfg.nLabKip : cfg.nLab);
        var hh = Math.min(23, Math.floor(now)), mm = Math.floor((now - Math.floor(now)) * 60);
        var clk = p >= 1 ? 'Midnight' : String(hh).padStart(2, '0') + ':' + String(mm).padStart(2, '0');
        set(el.clock, clk);
        var inW = kip && p < 1 && inV(now); if (el.tag._in !== inW) { tog(el.tag, 'in', inW); el.tag._in = inW; }
        if (!Wd) measure();
        var hx = (Math.min(now, 23.999) - T0) / SPAN * Wd, w = tw(clk);
        xform(head, 'translateX(' + hx.toFixed(1) + 'px)');
        xform(el.tag, 'translateX(' + Math.max(0, Math.min(Wd - w, hx - w / 2)).toFixed(1) + 'px)');
      }
      function tick() { var e = Date.now() - t0; if (e > D + HOLD) { t0 = Date.now(); e = 0; } p = Math.min(1, e / D); render(); }
      function loop() { if (!running) return; tick(); raf = requestAnimationFrame(loop); }
      function start() { if (running || RM) return; running = true; raf = requestAnimationFrame(loop); }
      function stop() { running = false; if (raf) cancelAnimationFrame(raf); raf = 0; }
      function replay() { if (RM) { p = 1; render(); return; } stop(); t0 = Date.now(); p = 0; render(); start(); }
      el.sw.addEventListener('click', function () {
        kip = !kip; tog(root, 'is-kip', kip);
        el.sw.setAttribute('aria-checked', kip ? 'true' : 'false'); set(el.sub, kip ? cfg.swOn : cfg.swOff);
        if (kip && !RM) { root.classList.remove('kd-hush'); void root.offsetWidth; root.classList.add('kd-hush'); setTimeout(function () { root.classList.remove('kd-hush'); }, 1000); }
        replay();
      });
      function relayout() { measure(); render(); }
      var mob = window.matchMedia('(max-width: 989px)');
      if (mob.addEventListener) mob.addEventListener('change', relayout);
      if ('ResizeObserver' in window) new ResizeObserver(function () { if (band.clientWidth !== Wd) relayout(); }).observe(band);
      else window.addEventListener('resize', relayout);
      render();
      /* plays once it is on screen and stays on the distracted day until someone switches kip on themselves */
      if (IO) {
        var started = false;
        new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (e.isIntersecting) { if (!started) { started = true; replay(); } else if (!running && !RM) { t0 = Date.now() - p * D; start(); } }
            else stop();
          });
        }, { threshold: 0.2 }).observe(root);
      } else replay();
      /* for checking the panel at any moment of the day */
      root._kd = { stop: stop, at: function (pp, k) { stop(); if (!!k !== kip) el.sw.click(); stop(); p = clamp(pp, 0, 1); measure(); render(); } };
    });
  }

  /* ---------- smooth scroll: Lenis, as on For Business (wheel only; touch stays native; reduced motion honoured) ---------- */
  function lenis() {
    /* touch already scrolls natively, and Lenis would only add blocking touch listeners and a class flip on every swipe */
    if (window.lenis || RM || !FINE.matches) return;
    var boot = function () {
      if (window.lenis || typeof window.Lenis !== 'function') return;
      window.lenis = new window.Lenis({ autoRaf: true, anchors: true, stopInertiaOnNavigate: true });
    };
    if (typeof window.Lenis === 'function') { boot(); return; }
    if ($('script[data-kh-lenis]')) return;
    var sc = document.createElement('script');
    sc.src = 'https://unpkg.com/lenis@1.3.26/dist/lenis.min.js';
    sc.async = true; sc.setAttribute('data-kh-lenis', ''); sc.onload = boot;
    document.head.appendChild(sc);
  }

  /* ---------- the product section's opener carries a number too: one more than the section before it ---------- */
  function kept() {
    if (BARE) return;
    /* the buy box is the page's own #tag, so every Get your kip tag can land on it */
    var kt = $('.kt-section'); if (kt && !document.getElementById('tag')) kt.id = 'tag';
    var e = $('.kt-eyebrow');
    if (!e || $('.kh-eye-n', e)) return;
    var prev = null;
    $$('.kh-eye-n').forEach(function (n) { if (n.compareDocumentPosition(e) & 4) prev = n; });
    /* pages that don't number their sections (the shop) leave the buy box unnumbered too */
    if (!prev) return;
    var k = parseInt(prev.textContent, 10);
    if (!k && k !== 0) return;
    var num = k + 1;
    e.insertAdjacentHTML('afterbegin', '<span class="kh-eye-n">' + (num < 10 ? '0' : '') + num + '</span>');
  }

  function init(scope) {
    scope = scope || document;
    rise(scope); accordions(scope); films(scope); reels(scope); moments(scope); day(scope);
    fitHero(); driftHero(); kept();
  }

  window.KH = { v: '1.0', init: init };

  function start() {
    init(document);
    lenis();
    requestAnimationFrame(function () { requestAnimationFrame(function () { docEl.classList.add('kh-ready'); }); });
    setTimeout(function () { docEl.classList.add('kh-ready'); }, 900);
    /* only a real width change re-fits the hero: the phone toolbar sliding in and out changes the height alone */
    var fitW = window.innerWidth;
    window.addEventListener('resize', function () { if (window.innerWidth !== fitW) { fitW = window.innerWidth; fitHero(); } reqDrift(); }, { passive: true });
    window.addEventListener('load', fitHero);
    window.addEventListener('scroll', reqDrift, { passive: true });
    /* the hover pause is for a cursor; on touch it would only restyle the whole page twice per swipe */
    if (FINE.matches) window.addEventListener('scroll', scrolling, { passive: true });
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();